import { Typography } from '@altify/components';
import { toSentenceCase } from 'utils/casing';

interface LoadingStepsProps {
  steps: string[];
  productCodesAndNames: string[];
}

/**
 * Displays loading steps while AI processes the question
 */
export function LoadingSteps({
  steps,
  productCodesAndNames,
}: LoadingStepsProps) {
  return (
    <div className="flex flex-col text-grey">
      {steps
        .filter((_, index) => index % 3 === 0)
        .map((step, index) => (
          <Typography
            size="medium"
            key={`thinking-step-${index}`}
            className="text-neutral-300">
            {toSentenceCase(step, productCodesAndNames)}
          </Typography>
        ))}
    </div>
  );
}
